import type { client as Client } from '@/client/client.gen'

/**
 * Stamp the HTTP status onto every error the generated client throws.
 *
 * With `throwOnError` the client throws the response body — the backend's
 * envelope, which carries a type and a message but no status. The query
 * client's retry rule skips 4xx by reading `error.status`; without it, a 404
 * or a 403 was retried twice and the page sat on its skeleton for seconds
 * before saying what was wrong.
 *
 * Non-enumerable, so the body still reads (and compares) as the backend sent it.
 */
export function stampErrorStatus(client: typeof Client): void {
  client.interceptors.error.use((error, response) => {
    if (typeof error === 'object' && error !== null && !('status' in error)) {
      Object.defineProperty(error, 'status', { value: response.status, enumerable: false })
    }
    return error
  })
}
